<template>
	<section class="store-content store-content--review-cart">

		<div class="store-content__top clearfix">
			<div class="store-content__top__links store-content__top__links--left">
			
			</div>
			<div class="store-content__top__title-container">
				<h2 class="store-content__top__title">
					<i class="icon icon-shopping-bag"></i>
					<span 
						v-html="stepTitle"
						class="store-content__top__title__text"
					></span>
				</h2>
			</div>
			<div class="store-content__top__links store-content__top__links--right">
			
			</div>		
		</div>

		<div
			v-if="reviewCartNotice"
			class="row"
		>
			<div class="col-xxs-12">
				<div
					v-html="reviewCartNotice"
					class="review-cart__notice"
				></div>
			</div>
		</div>

		<div 
			:class="{ 'is-loading': is_fetching_items }"
			class="row"
		>
			<div 
				v-if="!cart_items.length"
				class="col-xxs-12"
			>
				<span class="warning">No products in cart.</span>
			</div>

			<div
				v-else
				class="col-xxs-12"
			>
				<CartItem
					v-for="item in cart_items"
					@edit_cart_item="handleEditCartItem( item )"
					@handle_delete_cart_item="handleDeleteCartItem( item.cart_item_key )"
					:key="item.cart_item_key"
					:item="item"
				/>
			</div>
		</div> 

		<div class="row push-bottom">
			<div class="col-xxs-12">
				<button 
					@click="goToSelectItems"
					class="btn btn--orange text--uppercase"
				>&plus; Add another item to your order</button>
			</div>
		</div>

		<div 
			class="row push-top"
			v-if="cart_items.length"
		>
			<div class="col-xxs-12 col-sm-6 col-md-8">
				<h3 class="cart-extras__headline">
					<i class="icon icon-plus"></i>
					Add an Extra
				</h3>
				<div class="cart-extras">
					<CartExtra
						v-for="extra in extras"
						:key="extra.id"
						:extra="extra"
						@handle_added_extra="handleAddedExtra"
					/>
				</div>
			</div>

			<div class="col-xxs-12 col-sm-6 col-md-4">
				<button 
					@click="goToCheckout"
					class="btn btn--red text--uppercase btn--full-width"
				>Proceed to checkout
				</button>
			</div>
		</div>
	</section>
</template>


<script>
	import CartItem from '../components/CartItem.vue'
	import CartExtra from '../components/CartExtra.vue'


	export default {
		name: 'StepReviewCart',
		components: {
			CartItem,
			CartExtra,
		},

		props: {
			cart_items: {
				type: Array,
				default() {
					return []
				}
			},

			extras: {
				type: Object,
				default() {
					return []
				}
			},

			is_fetching_items: {
				type: 		Boolean,
				// default: 	false,
			},

			messages: {
				type: Object,
				required: true,
			},

			order_types: {
				type: 		Object,
				required: 	true
			},

			user_ordertype: {
				type: 		Function,
				default() {
					return ''
				}
			},
		},

		data() {
			return {
				stepTitle: 'Review Cart'
			}
		},


		computed: {
			reviewCartNotice() {
				let notice = ''

				if( 'delivery' === this.user_ordertype ) {
					if( this.order_types.delivery.hasDelivered ) {
						notice = this.messages.delivery_closed_review_cart
					}
				}

				return notice
			}
		},


		methods: {
			handleEditCartItem( cartItem ) {
				this.$emit( 'edit_cart_item', cartItem, true )
			},


			handleDeleteCartItem( cartItemKey ) {
				this.$emit( 'remove_cart_item', cartItemKey )
			},


			goToSelectItems() {
				this.$emit( 'go_to_step', 'Select Items', true )
			},


			goToCheckout() {
				this.$emit( 'go_to_step', 'Checkout' )
			},


			handleAddedExtra( cartItems ) {
				this.$emit( 'populate_cart_items', cartItems )
			}

		}

	}
</script>